// Wolf final results (frame plug-in): money owed + Wolf win-loss record, plus a
// hole-by-hole breakdown (Wolf, decision, who won, the hole's stake). Settled
// CORRECTLY from the actual wolf picks (the iOS app mis-settles as lowest-score;
// repaired here — logged to fix iOS later). No 3/2/1 points.
const cell = { border: '1px solid #ddd', padding: '6px 10px', fontSize: 16 }
// Whole dollars only — mirrors the app (never shows cents).
const money = (v) => (Math.round(v) === 0 ? '$0' : v > 0 ? `+$${Math.round(v)}` : `−$${Math.round(-v)}`)

export default function GWolfResults({ game, result }) {
  if (!result?.rows) return <p className="text-gray-500 text-sm">Enter scores to see results.</p>
  const players = game.players || []
  const name = (id) => players.find((p) => p.id === id)?.name || id
  const decision = (h) => {
    if (!h.played) return '—'
    if (h.loneWolf) return `Lone${h.blind ? ' (blind)' : ''}${h.howl ? ' 🔊' : ''}`
    const partners = h.teamIds.filter((id) => id !== h.wolfId).map(name).join(' + ')
    return `w/ ${partners || '—'}${h.howl ? ' 🔊' : ''}`
  }

  return (
    <div>
      <table className="w-full text-base mb-4" style={{ borderCollapse: 'collapse' }}>
        <thead><tr style={{ background: '#f6f6f2', color: '#555' }}>{['Pos', 'Player', 'Money', '🐺 W-L'].map((h) => <th key={h} style={{ ...cell, textAlign: 'left' }}>{h}</th>)}</tr></thead>
        <tbody>{result.rows.map((r, i) => (
          <tr key={r.id}>
            <td style={cell}>{i + 1}</td><td style={cell}>{r.name}</td>
            <td style={cell}><b style={{ color: r.net > 0 ? '#1B7A3E' : r.net < 0 ? '#B42318' : '#374151' }}>{money(r.net)}</b></td>
            <td style={cell} className="g-muted">{r.w}–{r.l}</td>
          </tr>
        ))}</tbody>
      </table>

      <div className="text-xs font-bold uppercase tracking-wide text-gray-500 mb-1">Hole-by-hole</div>
      <table className="w-full text-base" style={{ borderCollapse: 'collapse' }}>
        <thead><tr style={{ background: '#f6f6f2', color: '#555' }}>{['#', 'Wolf', 'Decision', 'Won by', 'Stake'].map((h) => <th key={h} style={{ ...cell, textAlign: 'left' }}>{h}</th>)}</tr></thead>
        <tbody>{result.holes.map((h) => (
          <tr key={h.hole}>
            <td style={cell}>{h.hole}</td>
            <td style={cell}>{name(h.wolfId)}</td>
            <td style={cell}>{decision(h)}</td>
            <td style={cell} className="g-muted">{!h.played ? '' : h.winnerSide === 'wolf' ? 'Wolf' : h.winnerSide === 'field' ? 'Field' : 'Push'}</td>
            <td style={cell}>${Math.round(h.played ? h.betVal : h.holeValue)}</td>
          </tr>
        ))}</tbody>
      </table>
    </div>
  )
}
